import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Dialog, DialogContent, DialogActions, DialogContentText, Button, DialogTitle } from '@material-ui/core'
import MaterialInputable from './MaterialInputable'
import Address from './Address'
import FormValidator from './FormValidator'
import api from '../api'

class AddressDialog extends React.Component {
	constructor(props) {
		super(props)

		this.addressComponent = React.createRef()

		this.validator = new FormValidator([
			{
				field: 'accountName',
				method: 'isEmpty',
				validWhen: false,
				message: 'Customer Name is required'
			},
			{
				field: 'accountNumber',
				method: 'isEmpty',
				validWhen: false,
				message: 'Fleet Store Account Number is required'
			},
			{
				field: 'accountNumber',
				method: this.accountExists,
				validWhen: false,
				message: 'Fleet Store Account Number must be unique per Dealer'
			},
		])

		this.state = {
			accountId: props.accountId || -1,
			accountName: props.accountName || '',
			accountNumber: props.accountNumber || '',
			addressId: props.addressId || -1,
			address: props.address,
			validation: this.validator.valid()
		}

		this.onClose = this.onClose.bind(this)
		this.validate = this.validate.bind(this)
		this.updateCountry = this.updateCountry.bind(this)
		this.updateAccountName = this.updateAccountName.bind(this)
		this.updateAccountNumber = this.updateAccountNumber.bind(this)
		this.updateAddress = this.updateAddress.bind(this)
	}

	async accountExists(accountNumber, state, props) {
		if (accountNumber === props.accountNumber ) {
			return false
		}

		const accountResponse = await api.service('localAccounts').find({
			query: {
				account_number: { $eq: accountNumber },
				dealer_location_id: { $eq: state.dealerLocationId }
			}
		})

		return (accountResponse.total > 0)
	}

	updateCountry(event) {
		let address = Object.assign({}, this.state.address)

		address.countryId = event.target.value
		this.setState({ address: address })
	}

	updateAccountName(event) {
		let validation = Object.assign({}, this.state.validation)
		validation['accountName'].isInvalid = false
		validation['accountName'].message = ''

		this.setState({
			accountName: event.target.value,
			validation: validation
		})
	}

	updateAccountNumber(event) {
		let validation = Object.assign({}, this.state.validation)
		validation['accountNumber'].isInvalid = false
		validation['accountNumber'].message = ''

		this.setState({
			accountNumber: event.target.value,
			validation: validation
		})
	}

	updateAddress(event) {
		let address = Object.assign({}, this.state.address)

		const name = event.target.name
		const value = event.target.value

		address[name] = value

		this.setState({ address: address })
	}

	/**
	 * Performs validation of the data in the dialog.
	 * @param {event} event - the calling event
	 * @returns {boolean} - is the form valid?
	 * @public
	 */
	async validate(event) {
		const validation = await this.validator.validate(this.state, this.props)
		this.setState({ validation })

		const addressIsValid = await this.addressComponent.current.isValid()

		if (!validation.isValid || !addressIsValid) {
			return false
		}

		const { accountId, accountName, accountNumber, addressId, address } = this.state

		await api.service('localAccounts').patch(accountId, {
			name: accountName,
			accountNumber: accountNumber,
		})

		await api.service('addresses').patch(addressId, {
			address: address.address,
			address2: address.address2,
			city: address.city,
			state: address.state,
			zip: address.zip,
			countryId: address.countryId ? address.countryId : 'USA'
		})

		if (this.props.onUpdate) {
			this.props.onUpdate(addressId, address, accountNumber, accountName)
		}

		if (this.props.onClose) {
			this.props.onClose()
		}

		return true
	}

	/**
	 * Clears the current state of the dialog.
	 * @returns {void} void
	 * @public
	 */
	clearState() {
		let address = Object.assign({}, this.state.address)

		Object.keys(address).forEach(key => {
			address[key] = ''
		})
		address.countryId = 'USA'

		this.setState({
			accountId: -1,
			accountNumber: '',
			accountName: '',
			addressId: -1,
			address: address,
		})
	}

	/**
	 * Handles the onClose event for the dialog
	 * @returns {void} void
	 * @public
	 */
	onClose() {
		this.clearState()

		if (this.props.onClose)
			this.props.onClose()
	}

	/**
	 * Renders the current dialog component
	 * @returns {ReactNode} the rendered react component
	 * @public
	 */
	render() {
		const { validation, accountName, accountNumber, address } = this.state

		return (
			<Dialog
				open={this.props.open}
				onClose={this.props.onClose}
				aria-labelledby="form-dialog-title"
				maxWidth='md'
			>
				<DialogTitle>Edit Account</DialogTitle>

				<DialogContent>
					<DialogContentText>
						Please update the information for the account.
					</DialogContentText>

					<Grid container spacing={1}>
						<Grid item xs={12} sm={6}>
							<MaterialInputable
								required
								name="accountName"
								label="Customer Name"
								value={accountName}
								error={validation.accountName.isInvalid}
								errorMessage={validation.accountName.message}
								onChange={this.updateAccountName} />
						</Grid>
						<Grid item xs={12} sm={6}>
							<MaterialInputable
								required
								name="accountNumber"
								label="Fleet Store Account Number"
								value={accountNumber}
								error={validation.accountNumber.isInvalid}
								errorMessage={validation.accountNumber.message}
								onChange={this.updateAccountNumber} />
						</Grid>
						<Grid item xs={12}>
							<Address
								required
								extendedAddress
								values={address}
								ref={this.addressComponent}
								onChange={event => this.updateAddress(event)}
								onSelectChange={event => this.updateAddress(event)} />
						</Grid>
					</Grid>
				</DialogContent>

				<DialogActions>
					<Button onClick={this.validate} color="secondary">Save</Button>
					<Button onClick={this.onClose} color="primary">Exit</Button>
				</DialogActions>
			</Dialog>
		)
	}
}

AddressDialog.propTypes = {
	classes: PropTypes.object,
	countryTypeOptions: PropTypes.array.isRequired,
	addressId: PropTypes.number.isRequired,
	accountNumber: PropTypes.string.isRequired,
	accountName: PropTypes.string.isRequired,
	address: PropTypes.object.isRequired,
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func,
	onUpdate: PropTypes.func,
}

export default AddressDialog


// WEBPACK FOOTER //
// ./src/components/AddressDialog.jsx